import React from 'react';
import './index.styl';

const clzpre = 'ssfe-bimmodel';

export default () => <iframe title="bimmodel" className={clzpre} src="http://123.57.68.26/bim/"></iframe>;
